import React from 'react';
import { Hexagon } from '../hexagon';
// This component is used for the SuperCard top-right icon. This probably has
// room for refactor
export const HexagonBadge = (props)=>/*#__PURE__*/ React.createElement(Hexagon, props);

//# sourceMappingURL=hexagon-badge.js.map